import { render } from "./UserRedAccountList.vue?vue&type=template&id=91d81686"
import script from "./UserRedAccountList.vue?vue&type=script&lang=js"
export * from "./UserRedAccountList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__